/**
 * Communication type tags constants for filtering
 * Used to separate building-specific and partner-specific communication types
 */

/**
 * Communication types visible for Building context
 * Includes client-specific and shared communication types
 */
export const BUILDING_COMMUNICATION_TYPES = [
  'invoice',
  'document',
  'reminder',
  'clientSchedule',
  'clientSubstitute',
  'clientPartnerChange',
  'cleaningDayChange',
  'cleaningTimeChange',
  'review',
  'verification',
  'finance',
  'operational',
  'other',
  'contract',
  'claim'
];

/**
 * Communication types visible for Partner context
 * Includes partner-specific and shared communication types
 * NOTE: claim, verification, operational are visible in partner interface but recorded in building profile
 */
export const PARTNER_COMMUNICATION_TYPES = [
  'balance',
  'partnerBuildingSwitch',
  'partnerSubstitute',
  'offerPermanent',
  'offerSubstitute',
  'partnerScheduleManual',
  'partnerSchedule',
  'claim',
  'verification',
  'operational',
  'other'
];
